import {useMemo} from 'react'
import {Spinner} from 'react-bootstrap'
import {LuBellMinus, LuXCircle} from 'react-icons/lu'
import styled from 'styled-components'

interface NotificationBoxProps {
  type: 'loading-message' | 'error-message' | 'empty-message'
  text?: string
}

const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  height: 240px;

  small {
    font-size: 10px;
    font-weight: normal;
    color: #656565;

    &.errorMessage {
      color: red;
    }
  }
`

export const NotificationBox = ({text, type}: NotificationBoxProps) => {
  const icon = useMemo(() => {
    switch (type) {
      case 'loading-message':
        return <Spinner animation='border' variant='primary' />
      case 'error-message':
        return <LuXCircle color='red' size={32} />
      case 'empty-message':
        return <LuBellMinus color='#656565' size={32} />
      default:
        return <LuBellMinus color='#656565' size={32} />
    }
  }, [type])

  return (
    <StyledBox>
      {icon}
      <small>{text}</small>
    </StyledBox>
  )
}
